import React from 'react';
import Logo_png from '../Logo_png';
import HamburgerMenu from './HamburgerMenu';
import styles from '../css/modules/Header.module.css';

const Header = () => {
  return (
    <header className={styles.headerBackground}>
      <div className={styles.logoContainer}>
        <Logo_png size="100px" />
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.hamburgerContainer}>
          <HamburgerMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
